export class User {

    userId!: string;
    firstName!: string;
	lastName!: string;
	password!: string;
	phoneNumber!: string;
	email!: string;
	dateOfBirth!: string;
	gender!: string;

    addressId!: string;
	addressLine1!: string;
	addressLine2!: string;

	countryDialCode : any;

	city!: string;
	country!: string;
	state!: string;
    zipCode!: string;
    fkUserId!: string;

    roleId!: string;
	officeId!: string;
    
}
